import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import '../App.css';

const LanguageSelector = () => {
  const { language, changeLanguage } = useLanguage();

  return (
    <div className='language-selector'>
      <button
        className={`lang-button ${language === 'en' ? 'active' : ''}`}
        onClick={() => changeLanguage('en')}
        title="English"
      >
        EN
      </button>
      <button
        className={`lang-button ${language === 'el' ? 'active' : ''}`}
        onClick={() => changeLanguage('el')}
        title="Ελληνικά"
      >
        EL
      </button>
    </div>
  );
};

export default LanguageSelector;



